var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn orcaBtn",staticStyle:{"min-width":"150px","background-color":"red"},attrs:{"disabled":_vm.adminBusy,"type":"button"},on:{"click":_vm.run}},[(!_vm.adminBusy)?_c('span',[_vm._v(_vm._s(_vm.hard ? 'Force ' : '')+"Reset")]):_c('span',[_vm._v("Working...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }